export const experience = [
    {
        img: "/images/wrstbnd.png",
        name: "Wrstbnd",
        info:  "Wrstbnd has challenged me to construte client forward ideas in an agile methodology, while constantly challening my creative thinking." ,
        timeFrame: "Feb/2022 - Oct/2022",
        tech: "Mendix & React"
    },{
        img: "https://www.cerberus.agency/wp-content/uploads/2021/12/Menu-Logo-CSS-new.svg",
        name: "Cerberus Agency",
        info:  "My time at Cerberus has been spent honing my skills making fully responsive and aesthetically pleasing websites for our clients while maintaing a postive UI/UX." ,
        timeFrame: "June/2020 - Jan/2022",
        tech: "WordPress, React, jQuery, HTML, CSS, Shopify"
    },
     {
        img: "/images/hallebot.jpeg",
        name: "Operation Spark",
        info: "Upon completeing Boot Camp at Operation Spark, I worked with the teachers to assist in the teaching of newer classes, as well as answering questions for students in the Junior and Senior phases of the program.",
        timeFrame: "Jan/2019 - May/2020",
        tech: "JavaScript(ES6)"
    }
];